/**
* Custom conditional debug logging.
*/
(function () {
  window.debug = {
    data: debugData,
    analytics: debugAnalytics,
    image: debugImage,
    performanceStart: debugPerformanceStart,
    performanceEnd: debugPerformanceEnd,
  }

  /**
  * Custom debug log that will only print if user has requested to see data
  * related console logs.
  */
  function debugData() {
    if (canDebug('debug.data')) {
      const args = [].slice.call(arguments)


      const styledCalls = ['GET', 'POST', 'PATCH', 'PUT', 'SUCCESS', 'FAILURE']

      if (styledCalls.indexOf(args[0]) === -1) {
        args.unshift('DATA')
      }
      args.unshift('background: green; color: white;')
      args.unshift('%c%s')

      return console.log.apply(this, args)
    }
  }

  /**
  * Custom debug log that will only print if user has requested to see analytics
  * related console logs.
  */
  function debugAnalytics() {
    if (canDebug('debug.analytics')) {
      const args = [].slice.call(arguments)


      const styledCalls = [
        'EVENT', 'PRODUCT IMPRESSION', 'PRODUCT CLICK', 'PRODUCT DETAILS',
        'ADD TO CART', 'REMOVE FROM CART', 'PROMOTION IMPRESSION',
        'PROMOTION CLICK', 'CHECKOUT', 'PURCHASE',
      ]

      if (styledCalls.indexOf(args[0]) === -1) {
        args.unshift('ANALYTICS')
      }
      args.unshift('background: purple; color: white;')
      args.unshift('%c%s')

      return console.log.apply(this, args)
    }
  }

  /**
  * Custom debug log that will only print if user has requested to see image
  * related console logs.
  */
  function debugImage() {
    if (canDebug('debug.images')) {
      const args = [].slice.call(arguments)


      const styledCalls = ['SUCCESS', 'FAILURE']

      if (styledCalls.indexOf(args[0]) === -1) {
        args.unshift('IMAGE')
      }
      args.unshift('background: blue; color: white;')
      args.unshift('%c%s')

      return console.log.apply(this, args)
    }
  }

  /**
  * Custom debug timer that will only start if user has requested to see performance
  * related console logs.
  */
  function debugPerformanceStart() {
    if (canDebug('debug.performance')) {
      return console.time.apply(this, arguments)
    }
  }

  /**
  * Custom debug timer that will only end if user has requested to see performance
  * related console logs.
  */
  function debugPerformanceEnd() {
    if (canDebug('debug.performance')) {
      return console.timeEnd.apply(this, arguments)
    }
  }

  /**
  * Returns true if user has the given type of debug logging enabled.
  */
  function canDebug(type) {
    return sessionStorage && type && JSON.parse(sessionStorage.getItem(type))
  }
}())
